module.exports = __webpack_public_path__ + "static/media/school-a.08be8576.jpg";